import React, { Component } from "react"
import { graphql } from "gatsby"
import "components/FlexibleContent/AcfFlexibleContent"
import Layout from "components/Layout/Layout"
import PageTitle from "components/shared/PageTitle"
import FlexibleContent from "components/FlexibleContent/FlexibleContent"

class DefaultTemplate extends Component {
	render() {
		const data = this.props.data.wordpressPage

		return (
			<Layout data={data}>
                {data.acf.display_page_title === "yes" &&
                    <PageTitle title={data.title} />
                }
				<FlexibleContent data={data} />
			</Layout>
		)
	}
}

export default DefaultTemplate

export const query = graphql`
query($id: String!) {
	wordpressPage(id: { eq: $id }) {
		id
		lang
		template
		title
		acf {
            display_page_title
            blocks_page {
                ...AcfFlexibleContent
            }
		}
	}
}
`